// extracted by mini-css-extract-plugin
module.exports = {"loader":"InfinityScroll_loader__1dxRX"};